<template>
  <!--
    规则问题情况、字段明细情况详情页面
    type: 【0：规则问题情况】【1：字段明细情况】
  -->
  <el-card
    id="qualityTaskDetail"
    class="normal h-full"
    :body-style="{ padding: '20px', height: '100%' }"
  >
    <el-row class="flex" style="position: relative">
      <div v-if="type === '0'" class="dib b">
        <span>{{ dateTime + '-' + taskItem.ruleName + '详情' }}</span>
      </div>
      <div v-if="type === '1'" class="dib b">
        <span class="mr-10px">时间：{{ dateTime }}</span>
        <span class="mr-10px">数据表：{{ taskItem.tableName }}</span>
        <span>字段名称：{{ taskItem.classAttributeName }}</span>
      </div>
      <el-button @click="back" class="back-btn" size="small">返回</el-button>
    </el-row>
    <!--规则问题情况-->
    <div v-if="type === '0'" style="height: calc(100% - 32px)">
      <el-row class="h-full">
        <el-col :span="10" class="h-full">
          <el-row class="mb-10px">
            <el-input
              class="mr-10px"
              style="width: 240px"
              clearable
              filterable
              v-model="problemSearch.keyword"
              placeholder="请输入内容"
              size="small"
            ></el-input>
            <el-button @click="getRuleLeft" type="primary" size="small">搜索</el-button>
          </el-row>
          <el-row style="height: calc(100% - 43px)">
            <vxe-table
              :loading="loading.ruleLeftTable"
              ref="leftTable"
              :data="classListData"
              height="100%"
              style="width: 100%"
              border
              highlight-current-row
              @cell-click="getRuleDetail"
            >
              <vxe-table-column field="className" title="实体中文名称"></vxe-table-column>
              <vxe-table-column title="属性英文名称">
                <template slot-scope="scope">
                  <span>{{ _.get(scope.row.classAttribute, 'code') }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column title="属性中文名称">
                <template slot-scope="scope">
                  <span>{{ _.get(scope.row.classAttribute, 'name') }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column title="来源系统">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.classAttribute && scope.row.classAttribute.dynamicColumnData
                        ? _.get(
                            _.find(scope.row.classAttribute.dynamicColumnData, {
                              actualAttributeColumnName: '来源系统',
                            }),
                            'value'
                          )
                        : null
                    }}
                  </span>
                </template>
              </vxe-table-column>
              <vxe-table-column title="来源数据表">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.classAttribute && scope.row.classAttribute.dynamicColumnData
                        ? _.get(
                            _.find(scope.row.classAttribute.dynamicColumnData, {
                              actualAttributeColumnName: '来源数据表',
                            }),
                            'value'
                          )
                        : null
                    }}
                  </span>
                </template>
              </vxe-table-column>
              <vxe-table-column title="来源数据字段">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.classAttribute && scope.row.classAttribute.dynamicColumnData
                        ? _.get(
                            _.find(scope.row.classAttribute.dynamicColumnData, {
                              actualAttributeColumnName: '来源数据字段',
                            }),
                            'value'
                          )
                        : null
                    }}
                  </span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </el-row>
        </el-col>
        <el-col :span="14" class="h-full pl-20px">
          <el-row>
            <el-input
              class="mr-10px"
              style="width: 240px"
              v-model="detailSearch"
              placeholder="搜索类别代码或类别名称"
              size="small"
            ></el-input>
            <el-button @click="getRuleDetail" type="primary" size="small">搜索</el-button>
            <el-button size="small" @click="exportRuleDetail" :loading="loading.ruleExport"
              >导出</el-button
            >
          </el-row>
          <el-row class="mt-10px" style="height: calc(100% - 85px)">
            <vxe-table
              :loading="loading.ruleRightTable"
              :data="problemData"
              height="100%"
              class="w-full"
              border
              stripe
              highlight-current-row
            >
              <vxe-table-column
                type="seq"
                title="序号"
                width="60"
                align="center"
              ></vxe-table-column>
              <vxe-table-column field="prop" title="数据类型" header-class-name="bg-blue">
                <template slot-scope="scope">
                  <span>{{ _.get(scope.row.classAttribute, 'valueTypeName') }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column title="数据长度" header-class-name="bg-blue">
                <template slot-scope="scope">
                  <span>{{ _.get(scope.row.classAttribute, 'length') }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="referenceData"
                title="参考数据"
                header-class-name="bg-blue"
              ></vxe-table-column>
              <vxe-table-column title="规则表达式" header-class-name="bg-blue">
                <template slot-scope="scope">
                  <span>{{ _.get(scope.row.classAttribute, 'ruleExpression') }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="dataValue" title="检查数据值"></vxe-table-column>
              <vxe-table-column field="dataValueLength" title="数据值长度"></vxe-table-column>
              <vxe-table-column
                field="referenceClassAttributeValue"
                title="引用真实值"
                header-class-name="bg-blue"
              ></vxe-table-column>
              <vxe-table-column title="检查结果" align="center">
                <template>
                  <span>异常</span>
                </template>
              </vxe-table-column>
              <vxe-table-column field="exceptionCause" title="异常原因"></vxe-table-column>
            </vxe-table>
          </el-row>
          <el-row class="mt-10px">
            <el-pagination
              class="r"
              background
              @size-change="problemSizeChange"
              @current-change="problemCurrentChange"
              :current-page.sync="problem.pageNo"
              :page-sizes="[10, 20, 50, 100]"
              :page-size.sync="problem.pageSize"
              layout="->, total, sizes, prev, pager, next"
              :total="this.problem.total"
            ></el-pagination>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!--字段明细情况-->
    <div v-if="type === '1'" style="height: calc(100% - 32px)">
      <el-select
        class="mr-10px"
        v-model="fieldSearch.problemType"
        @change="getFieldDetail"
        placeholder="选择问题类型"
        size="small"
        filterable
        clearable
      >
        <el-option
          v-for="(item, index) in ruleTypeList"
          :key="index"
          :label="item.displayName"
          :value="item.displayName"
        ></el-option>
      </el-select>
      <el-input
        class="mr-10px"
        style="width: 180px"
        v-model="fieldSearch.keyword"
        @keyup.enter.native="getFieldDetail"
        @clear="getFieldDetail"
        placeholder="检查值及真实值"
        size="small"
        clearable
      ></el-input>
      <el-button @click="getFieldDetail" type="primary" size="small">搜索</el-button>
      <el-button size="small" @click="exportFieldDetail" :loading="loading.fieldExport"
        >导出</el-button
      >
      <vxe-table
        :loading="loading.fieldTable"
        style="height: calc(100% - 85px)"
        class="mt-10px"
        border
        stripe
        :data="fieldData"
      >
        <vxe-table-column width="55" type="seq" title="序号" align="center"></vxe-table-column>
        <vxe-table-column
          field="ruleName"
          title="问题类型"
          header-class-name="bg-blue"
        ></vxe-table-column>
        <vxe-table-column title="数据类型" header-class-name="bg-blue">
          <template slot-scope="scope">
            <span>{{ _.get(scope.row.classAttribute, 'valueTypeName') }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="数据长度" header-class-name="bg-blue">
          <template slot-scope="scope">
            <span>{{ _.get(scope.row.classAttribute, 'length') }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="referenceData"
          title="参考数据"
          header-class-name="bg-blue"
        ></vxe-table-column>
        <vxe-table-column title="规则表达式" header-class-name="bg-blue">
          <template slot-scope="scope">
            <span>{{ _.get(scope.row.classAttribute, 'ruleExpression') }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="dataValue" title="检查数据值"></vxe-table-column>
        <vxe-table-column field="dataValueLength" title="数据值长度"></vxe-table-column>
        <vxe-table-column
          field="referenceClassAttributeValue"
          title="引用真实值"
          header-class-name="bg-blue"
        ></vxe-table-column>
        <vxe-table-column title="检查结果" align="center">
          <template>
            <span>异常</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="exceptionCause" title="异常原因"></vxe-table-column>
      </vxe-table>
      <el-pagination
        class="r mt-10px"
        background
        @size-change="fieldSizeChange"
        @current-change="fieldCurrentChange"
        :current-page.sync="field.pageNo"
        :page-size.sync="field.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="->, total, sizes, prev, pager, next"
        :total="this.field.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import QualityTaskService from '@/services/QualityTaskService'
import DataRuleSettingService from '@/services/DataRuleSettingService'
import dayjs from 'dayjs'

export default {
  name: 'qualityTaskDetail',
  mixins: [],
  components: {},
  data() {
    return {
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      loading: {
        ruleLeftTable: false,
        ruleRightTable: false,
        ruleExport: false,
        fieldTable: false,
        fieldExport: false,
      },
      taskItem: { date: '' },
      ruleTypeList: [],
      curAttributeId: {},
      classListData: [],
      // 规则问题情况详情
      problem: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      problemSearch: {
        keyword: '',
      },
      detailSearch: '',
      problemData: [],

      // 字段明细情况详情
      fieldSearch: {
        keyword: '',
        problemType: '',
      },
      fieldData: [],
      field: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {
    currentId() {
      return this.$route.query.taskId
    },
    type() {
      return this.$route.query.type
    },
    dateTime() {
      return dayjs(this.taskItem.date).format('YYYY年MM月')
    },
    taskRunId() {
      return this.$route.query.taskRunId
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  watch: {
    taskItem: {
      deep: true,
      handler(newVal) {
        if (this.type === '0') {
          this.getRuleLeft()
        } else {
          this.getFieldDetail()
          this.getRuleType()
        }
      },
    },
  },
  methods: {
    // 回退
    back() {
      this.problemSearch.keyword = ''
      this.fieldSearch = this.$options.data().fieldSearch
      this.detailSearch = ''
      localforage.setItem('taskItem', null)
      this.$router.push(
        `${this.basePath}/legacy-resource/data-quality-manage/quality-task-form?id=${this.$route.query.detailId}`
      )
    },
    // 获取规则详情左侧列表
    async getRuleLeft() {
      this.loading.ruleLeftTable = true
      const res = await QualityTaskService.getRuleDetailLeft({
        type: this.taskItem.type,
        task_run_id: this.taskRunId,
        keyword: this.problemSearch.keyword,
      })
      if (res && res.data && res.code === 0) {
        this.classListData = res.data
        this.curAttributeId = res.data[0] || {}
        this.$nextTick(() => {
          this.$refs.leftTable.setCurrentRow(res.data[0])
        })
        this.getRuleDetail()
      }
      this.loading.ruleLeftTable = false
    },
    // 导出规则详情
    async exportRuleDetail() {
      this.loading.ruleExport = true
      const res = await QualityTaskService.exportRuleDetail({
        pageno: 1,
        pagesize: 999,
        classId: this.curAttributeId.classId,
        taskRunId: this.taskRunId,
        attributeId: this.curAttributeId.classAttributeId,
        type: this.taskItem.type,
        keyword: this.detailSearch,
      })
      if (res && res.code === 0 && res.url) {
        window.open(`${this.currentEnv.VUE_APP_STANDARD_SERVER}/${res.url}`, '_blank')
      }
      this.loading.ruleExport = false
    },
    // 获取规则详情
    async getRuleDetail(obj = {}) {
      if (obj.row && obj.row.classId) {
        this.curAttributeId = obj.row
      }
      if (_.isEmpty(this.curAttributeId)) {
        return
      }
      this.loading.ruleRightTable = true
      const tableRes = await QualityTaskService.getRuleDetailData({
        classId: this.curAttributeId.classId,
        taskRunId: this.curAttributeId.taskRunId,
        attributeId: this.curAttributeId.classAttributeId,
        type: this.taskItem.type,
        keyword: this.detailSearch,
        pageNo: this.problem.pageNo,
        pageSize: this.problem.pageSize,
      })
      if (tableRes && tableRes.data && tableRes.code === 0) {
        this.problemData = tableRes.data
        this.problem.total = tableRes.page ? tableRes.page.recordCount : tableRes.data.length
      }
      this.loading.ruleRightTable = false
    },
    // 获取字典
    async getDic() {
      const res = await DataRuleSettingService.getDic({
        code: 'DATARULETYPE',
      })
      if (res && res.code === 0) {
        return _.head(res.data) || {}
      }
      return {}
    },
    // 获取规则类型
    async getRuleType() {
      const dic = await this.getDic()
      const dicRes = await DataRuleSettingService.getRuleClass({
        skipCount: 0,
        maxResultCount: 999,
        dataCategoryId: dic.id,
      })
      if (dicRes && dicRes.data && dicRes.code === 0) {
        this.ruleTypeList = dicRes.data
      }
    },
    // 导出字段明细详情
    async exportFieldDetail() {
      this.loading.fieldExport = true
      const res = await QualityTaskService.exportFieldDetail({
        pageno: 1,
        pagesize: 999,
        taskRunId: this.taskItem.taskRunId,
        classId: this.taskItem.classId,
        attributeId: this.taskItem.classAttributeId,
        keyword: this.fieldSearch.keyword,
        ruleName: this.fieldSearch.problemType,
      })
      if (res && res.code === 0 && res.url) {
        window.open(`${this.currentEnv.VUE_APP_STANDARD_SERVER}/${res.url}`, '_blank')
      }
      this.loading.fieldExport = false
    },
    // 获取字段明细详情
    async getFieldDetail() {
      this.loading.fieldTable = true
      const headerRes = await QualityTaskService.getRuleDetailHeader({
        class_id: this.taskItem.classId,
      })
      const tableRes = await QualityTaskService.getFieldDetail({
        taskRunId: this.taskItem.taskRunId,
        classId: this.taskItem.classId,
        attributeId: this.taskItem.classAttributeId,
        keyword: this.fieldSearch.keyword,
        ruleName: this.fieldSearch.problemType,
        pageNo: this.field.pageNo,
        pageSize: this.field.pageSize,
      })
      if (tableRes && tableRes.data && tableRes.code === 0) {
        this.fieldData = tableRes.data
        this.field.total = tableRes.page ? tableRes.page.recordCount : tableRes.data.length
      }
      this.loading.fieldTable = false
    },
    problemSizeChange(val) {
      this.getRuleDetail()
    },
    problemCurrentChange(val) {
      this.getRuleDetail()
    },
    fieldSizeChange(val) {
      this.getFieldDetail()
    },
    fieldCurrentChange(val) {
      this.getFieldDetail()
    },
  },
  async created() {
    this.taskItem = await localforage.getItem('taskItem')
  },
}
</script>
<style lang="scss" scoped>

.back-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.box-left {
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.box-ul {
  height: 100%;
  overflow-y: auto;
}
.box-li {
  height: 34px;
  line-height: 34px;
  padding: 0 10px;
  font-size: 14px;
}
.box-ul .active,
.box-li:hover {
  background: #1899fa;
  color: #fff;
}
.class-title {
  height: 40px;
  line-height: 40px;
}
/deep/ .bg-blue {
  background: #1899fa;
}

</style>
